import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { InputsModule } from '../../../../common/inputs/inputs.module';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService } from '../../../../../core/services/dialog.service';
import { LingRegExps } from '../../../../../core/data/ling-reg-exps';
import { SnackBarService } from '../../../../../core/services/snack-bar.service';
import { DocumentMimeType } from '../../../../../core/enums';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'ling-cert-parse-dialog',
  templateUrl: './cert-parse-dialog.component.html',
  styleUrls: ['./cert-parse-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    InputsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class CertParseDialogComponent implements OnInit {
  private readonly dialog = inject(DialogService);
  private readonly message = inject(SnackBarService);

  protected readonly documentMimeType = DocumentMimeType;

  protected readonly parseForm = new FormGroup({
    file: new FormControl<File[]>([]),
    url: new FormControl({ value: null, disabled: true }, [
      Validators.pattern(LingRegExps.link),
    ]),
  });

  protected readonly parseFormControlsNames = Object.keys(
    this.parseForm.controls
  );

  ngOnInit() {
    this.formControlsValueChangesListener();
  }

  formControlsValueChangesListener(): void {
    this.parseFormControlsNames.forEach((controlName, index) => {
      this.parseForm.get(controlName)!.valueChanges.subscribe((value) => {
        const hasValue = Array.isArray(value) ? !!value.length : !!value;

        this.parseFormControlsNames.forEach((otherName) => {
          if (otherName === controlName) {
            return;
          }

          const otherControl = this.parseForm.get(otherName)!;

          if (hasValue) {
            otherControl.disable({ emitEvent: false });
            console.log(this.parseForm);
            this.parseForm.updateValueAndValidity();
          } else {
            const anyOtherHasValue = this.parseFormControlsNames.some(
              (name) => {
                const controlValue = this.parseForm.get(name)!.value;
                const otherHasValue = Array.isArray(controlValue)
                  ? !!controlValue.length
                  : !!controlValue;

                return name !== controlName && otherHasValue;
              }
            );

            if (!anyOtherHasValue) {
              otherControl.enable({ emitEvent: false });
            }
          }
        });
      });
    });
  }

  onSubmit(): void {
    if (this.parseForm.invalid) {
      this.message.error('provide link');
      return;
    }

    const { file, url } = this.parseForm.value;
    const formValue = url ? { url } : { file: file?.at(0) };
    this.dialog.closeCurrent(formValue);
  }
}
